import React from 'react';
import {connect} from 'react-redux';
import {Grid} from '@mui/material';

import {Dispatch, SelectOption} from 'spectra-logic-ui';
import {createResource} from 'spectra-logic-ui/actions';
import {FormDialog, MultiSelect, TextField} from 'spectra-logic-ui/components';

import {Pool} from '@/types';
import {isCloud} from '@/storage/cloud';

export type FormValues = {
  name: string;
  ids: string[];
}

type Props = {
  pools: Pool[];
  onSubmit: (values: FormValues) => Promise<any>;
}

const CreateAggregateDialog = ({pools=[], onSubmit, ...others}: Props) => {
  const onPremiseStorage = pools.filter((p) => !isCloud(p));
  const storageOptions = onPremiseStorage.map((p) => {
    return {key: p.id, text: `${p.name} (${p.id})`};
  }) as SelectOption[];

  return (
    <FormDialog title='Create Storage Group' onSubmit={onSubmit} {...others}>
      {() => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField name='name' label='Name' />
          </Grid>
          <Grid item xs={12}>
            <MultiSelect name='ids' label='Storage' options={storageOptions} />
          </Grid>
        </Grid>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (values: FormValues) => {
    return dispatch(createResource('aggregates', values));
  },
});

export default connect(undefined, mapDispatchToProps)(CreateAggregateDialog);
